import { Box, Container, Grid, makeStyles } from "@material-ui/core";
import { connect } from "common/connect";
import { changeUrl } from "common/history";
import StoreKeys from "common/storeKeys";
import * as React from "react";
import { Helmet } from "react-helmet";
import { Colors } from "styles/Colors";
import { getRecentTools, groupByCategory, recordToolUse, visibleTools } from "./adminTools";

const propKeys = {
	roles: StoreKeys.ROLES,
};

const useStyles = makeStyles(() => ({
	root: {
		color: Colors.primary,
		paddingTop: 32,
		paddingBottom: 64,
	},
	section: {
		marginBottom: 21,
	},
	sectionHeader: {
		display: "flex",
		alignItems: "center",
		gap: 12,
		marginBottom: 14,
	},
	sectionLabel: {
		color: "#a8a8a8",
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: 2,
		textTransform: "uppercase",
		whiteSpace: "nowrap",
	},
	rule: {
		flex: 1,
		height: 1,
		backgroundColor: "#a8a8a8",
	},
	tile: {
		boxSizing: "border-box",
		display: "flex",
		alignItems: "flex-start",
		gap: 14,
		height: "100%",
		padding: 16,
		borderRadius: 12,
		backgroundColor: Colors.panel,
		border: `1px solid ${Colors.panelLight}`,
		cursor: "pointer",
		outline: "none",
		transition: "transform 120ms ease, background-color 120ms ease, border-color 120ms ease",
		"&:hover, &:focus-visible": {
			transform: "translateY(-2px)",
			backgroundColor: Colors.panelLight,
			borderColor: Colors.pickstop,
		},
	},
	iconWrap: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: 42,
		height: 42,
		flexShrink: 0,
		borderRadius: 10,
		color: Colors.primary,
		backgroundColor: Colors.panelDark,
		border: `1px solid ${Colors.panelLighterColor}`,
		transition: "color 120ms ease, border-color 120ms ease",
	},
	tileTitle: {
		fontSize: 15,
		fontWeight: 600,
		marginBottom: 4,
	},
	tileDesc: {
		fontSize: 13,
		lineHeight: 1.35,
		color: Colors.primaryDark,
	},
}));

function Tile({ tool, onOpen, classes }) {
	const Icon = tool.icon;
	const open = () => onOpen(tool);
	const onKeyDown = (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			open();
		}
	};
	return (
		<Grid item xs={12} sm={6} md={4}>
			<Box className={classes.tile} role="button" tabIndex={0} onClick={open} onKeyDown={onKeyDown}>
				<div className={classes.iconWrap}>
					<Icon fontSize="small" />
				</div>
				<div>
					<div className={classes.tileTitle}>{tool.title}</div>
					<div className={classes.tileDesc}>{tool.description}</div>
				</div>
			</Box>
		</Grid>
	);
}

function AdminLanding({ roles }) {
	const classes = useStyles();
	const tools = visibleTools(roles);
	const groups = groupByCategory(tools);
	const recent = getRecentTools(tools);

	const open = (tool) => {
		recordToolUse(tool.id);
		changeUrl(tool.path);
	};

	const renderSection = (label, sectionTools, key) => (
		<div className={classes.section} key={key}>
			<div className={classes.sectionHeader}>
				<span className={classes.sectionLabel}>{label}</span>
				<span className={classes.rule} />
			</div>
			<Grid container spacing={2}>
				{sectionTools.map((tool) => (
					<Tile key={tool.id} tool={tool} onOpen={open} classes={classes} />
				))}
			</Grid>
		</div>
	);

	return (
		<Container maxWidth="lg" className={classes.root}>
			<Helmet>
				<title>Pickstop - Admin</title>
			</Helmet>
			{recent.length > 0 && renderSection("Last used", recent, "recent")}
			{groups.map((group) => renderSection(group.category, group.tools, group.category))}
		</Container>
	);
}

function AdminScreen(props) {
	return connect(<AdminLanding />, propKeys, props);
}

export default AdminScreen;
